// extracted by mini-css-extract-plugin
module.exports = {"active_label":"PortfolioInput_active_label__VR2kh"};